import Modal from "../General/Modal"
import Image from "next/image"
import { closeEnquirySuccessModal } from "../../store/CoreSlice"
import { useDispatch } from "react-redux"

function EnquirySuccess({ show, user }: any) {
    const dispatch = useDispatch();
    
    const close = () => {
        dispatch(closeEnquirySuccessModal());
    }

    return (
        <Modal show={show} styles='w-[80%] lg:w-1/4' transition="animateup">
            <div className="content pt-4 pb-10 px-3">
                <div className="flex justify-end">
                    <svg onClick={close} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 cursor-pointer">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>

                <div className="flex justify-center items-center">
                    <img
                        src={'/Layout/EnquirySuccess.png'}
                        width={200}
                        height={200}
                        alt='Success'
                        className="pt-3 pb-6"
                    />
                </div>

                <div className="content text-center px-10">
                    <p className="text-theme-black font-semibold">Hey! {user}</p>

                    <p className="pt-2 text-theme-black font-light">
                        <span className="text-theme-orange font-semibold">Thank you </span>
                        for showing interest. We will get in touch with you with next steps within 24 Hours
                    </p>
                </div>
            </div>
        </Modal>
    )
}

EnquirySuccess.defaultProps = {
    user : ''
}

export default EnquirySuccess